import { countryFlag, countryLabel } from '@/lib/utils/phone';
import { cn } from '@/lib/utils/cn';

interface CountryBadgeProps {
  countryCode: string | null | undefined;
  className?: string;
}

export function CountryBadge({ countryCode, className }: CountryBadgeProps) {
  if (!countryCode || countryCode === 'UNKNOWN') {
    return <span className="text-fg-subtle">—</span>;
  }
  return (
    <span className={cn('inline-flex items-center gap-1 text-xs text-fg', className)}>
      <span aria-hidden>{countryFlag(countryCode)}</span>
      <span>{countryLabel(countryCode)}</span>
    </span>
  );
}
